import { provideIcons } from '@bpifrance/propulsion-icons';
import { ppPen_Edit_1 } from '@bpifrance/propulsion-assets/assets/Pen_Edit_1';
import { ppTrash_Delete_Bin } from '@bpifrance/propulsion-assets/assets/Trash_Delete_Bin';
import { ppEye_Show_Visible } from '@bpifrance/propulsion-assets/assets/Eye_Show_Visible';
import { ppDocument_File_2 } from '@bpifrance/propulsion-assets/assets/Document_File_2';
import { ppSearch_Loupe_Menu_Filter } from '@bpifrance/propulsion-assets/assets/Search_Loupe_Menu_Filter';
import { ppFile_Blank_Copy_Add_Plus } from '@bpifrance/propulsion-assets/assets/File_Blank_Copy_Add_Plus';
import { ppDelete_Disabled_1 } from '@bpifrance/propulsion-assets/assets/Delete_Disabled_1';
import { ppArrow_12  } from '@bpifrance/propulsion-assets/assets/Arrow_12';

export const iconsProvider = [provideIcons([ppPen_Edit_1, ppDelete_Disabled_1, ppSearch_Loupe_Menu_Filter, ppFile_Blank_Copy_Add_Plus, ppArrow_12, ppTrash_Delete_Bin, ppDocument_File_2, ppEye_Show_Visible])];
